import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronRight } from '@fortawesome/free-solid-svg-icons';
import WrapperCard from './WrapperCard';
import RouterSvg from '../../Res/router.svg';

const styles = {
  iconColumn: { padding: '25px 0', borderRight: '2px solid #F0F0F0' },
  faxCount: {
    fontSize: '42px',
    fontWeight: '600',
  },
  btn: {
    backgroundColor: '#A8A8AA',
    color: '#FFFFFF',
  },
  wrapperHeaderStyle: { color: '#FFFFFF', backgroundColor: '#3B5CA9' },
  faChevronRight: { marginLeft: '5px' },
};

function EdgeDevices({ isLoading, count }) {
  return (
    <WrapperCard
      isLoading={isLoading}
      title="Edge Devices"
      headerStyle={styles.wrapperHeaderStyle}
      contentSkeletons={2}
      enableCardBody={false}
      headerTooltip="Total number of EPIK Edge devices assigned"
    >
      <div className="row ml-0 mr-0 align-items-center">
        <div className="col-md-3" style={styles.iconColumn}>
          <img src={RouterSvg} />
        </div>
        <div className="col-md-4">
          <h4 style={styles.faxCount}>{count}</h4>
        </div>
        <div className="col-md-5">
          <Link to="/boxes">
            <button type="button" class="btn" style={styles.btn}>
              View Details
              <FontAwesomeIcon icon={faChevronRight} style={styles.faChevronRight} size="sm" />
            </button>
          </Link>
        </div>
      </div>
    </WrapperCard>
  );
}

export default EdgeDevices;
